module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "max_width_product_type"
  }, [_c('div', {
    staticClass: "layout-breadcrumb"
  }, [_c('Breadcrumb', [_c('BreadcrumbItem', [_c('Icon', {
    staticStyle: {
      "color": "#fff"
    },
    attrs: {
      "type": "social-buffer-outline"
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_vm._v("品种牌号管理")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "layout-content"
  }, [_c('div', {
    staticClass: "layout-content-main"
  }, [_c('div', {
    staticClass: "layout_content_left_tree treeLeft"
  }, [_c('Button', {
    staticClass: "layout_content_left_tree_btn",
    attrs: {
      "icon": "ios-plus-empty",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.append({
          'id': '0'
        })
      }
    }
  }), _vm._v(" "), _c('Tree', {
    ref: "tree",
    attrs: {
      "data": _vm.dataNews,
      "render": _vm.renderContent
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "treeRight"
  }, [_c('div', {
    staticClass: "houseTitle"
  }, [_vm._v("品种信息")]), _vm._v(" "), _c('Form', {
    ref: "formVarietyInformation",
    attrs: {
      "model": _vm.formVarietyInformation,
      "rules": _vm.ruleVarietyInfor,
      "label-width": 100,
      "label-position": "left"
    }
  }, [_c('div', {
    class: {
      formLine_order: !_vm.showProductTypeId, formLine: _vm.showProductTypeId
    }
  }, [_c('FormItem', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProductTypeId),
      expression: "showProductTypeId"
    }],
    attrs: {
      "label": "品种代码",
      "prop": "productTypeId"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.disabledInput,
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.productTypeId),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "productTypeId", $$v)
      },
      expression: "formVarietyInformation.productTypeId"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "form_line_item",
    attrs: {
      "label": "品种名称",
      "prop": "productTypeName"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.disabledInput,
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.productTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "productTypeName", $$v)
      },
      expression: "formVarietyInformation.productTypeName"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    attrs: {
      "label": "父级品种代码",
      "prop": "prodTypeFather"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.prodTypeFather),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "prodTypeFather", $$v)
      },
      expression: "formVarietyInformation.prodTypeFather"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "form_line_item",
    attrs: {
      "label": "级数",
      "prop": "prodTypeLevel"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.disabledInput,
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.prodTypeLevel),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "prodTypeLevel", $$v)
      },
      expression: "formVarietyInformation.prodTypeLevel"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formLine_order"
  }, [_c('FormItem', {
    staticClass: "form_line_item",
    attrs: {
      "label": "显示顺序",
      "prop": "orderNum"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": _vm.disabledInput,
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.orderNum),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "orderNum", $$v)
      },
      expression: "formVarietyInformation.orderNum"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "formLine"
  }, [_c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formVarietyInformation.remark),
      expression: "formVarietyInformation.remark"
    }],
    staticClass: "form_line_textarea",
    class: {
      form_line_textarea_edit: _vm.disabledInput
    },
    attrs: {
      "disabled": _vm.disabledInput,
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formVarietyInformation.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formVarietyInformation, "remark", $event.target.value)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProductTypeId),
      expression: "showProductTypeId"
    }],
    staticClass: "formLine"
  }, [_c('FormItem', {
    attrs: {
      "label": "创建人",
      "prop": "createBy"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.createBy),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "createBy", $$v)
      },
      expression: "formVarietyInformation.createBy"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    staticClass: "form_line_item",
    attrs: {
      "label": "创建时间",
      "prop": "createDate"
    }
  }, [_c('Input', {
    attrs: {
      "disabled": "",
      "placeholder": ""
    },
    model: {
      value: (_vm.formVarietyInformation.createDate),
      callback: function($$v) {
        _vm.$set(_vm.formVarietyInformation, "createDate", $$v)
      },
      expression: "formVarietyInformation.createDate"
    }
  })], 1)], 1), _vm._v(" "), _c('FormItem', [_c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabledInput),
      expression: "!disabledInput"
    }],
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.warehouseSubmit(_vm.formVarietyInformation)
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabledInput),
      expression: "disabledInput"
    }],
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.changeAdmin
    }
  }, [_vm._v("编辑")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.disabledInput),
      expression: "disabledInput"
    }],
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.warehousedelet
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('Button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.disabledInput),
      expression: "!disabledInput"
    }],
    staticClass: "mRight",
    attrs: {
      "type": "ghost"
    },
    on: {
      "click": function($event) {
        _vm.warehouseReset()
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "houseTitle"
  }, [_vm._v("牌号信息")]), _vm._v(" "), _c('div', {
    staticClass: "method-wrapper"
  }, [(_vm.isbutShow.selectBut) ? _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [
    [_c('Input', {
      staticStyle: {
        "width": "300px"
      },
      attrs: {
        "placeholder": "牌号信息"
      },
      model: {
        value: (_vm.key),
        callback: function($$v) {
          _vm.key = $$v
        },
        expression: "key"
      }
    })], _vm._v(" "), (_vm.isbutShow.selectBut) ? _c('Button', {
      staticClass: "mRight mLeft",
      attrs: {
        "type": "ghost"
      },
      on: {
        "click": function($event) {
          _vm.showKeyList()
        }
      }
    }, [_vm._v("查询")]) : _vm._e()
  ], 2) : _vm._e(), _vm._v(" "), (_vm.isbutShow.addBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addAdmin
    }
  }, [_vm._v("新增")]) : _vm._e(), (_vm.isbutShow.updateBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.upDateAdmin
    }
  }, [_vm._v("修改")]) : _vm._e(), _vm._v(" "), (_vm.isbutShow.delBut) ? _c('Button', {
    staticClass: "mRight",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delAdmins
    }
  }, [_vm._v("删除")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('Table', {
    ref: "selection",
    staticStyle: {
      "min-width": "600px"
    },
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.pagerData.data
    },
    on: {
      "on-selection-change": _vm.getSelection
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "10px",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Page', {
    attrs: {
      "total": _vm.pagerData.page.totalCount,
      "show-sizer": "",
      "show-elevator": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.onChange,
      "on-page-size-change": _vm.sizeChange
    }
  })], 1)])], 1)], 1)])]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "",
      "mask-closable": false
    },
    model: {
      value: (_vm.addModel),
      callback: function($$v) {
        _vm.addModel = $$v
      },
      expression: "addModel"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('Icon', {
    attrs: {
      "type": "information-circled"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.activeName))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Form', {
    ref: "formValidate",
    attrs: {
      "label-position": "left",
      "model": _vm.formValidate,
      "rules": _vm.ruleValidate,
      "label-width": 150
    }
  }, [_c('FormItem', {
    attrs: {
      "label": "品种名称",
      "prop": "productTypeName"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入品种名称"
    },
    model: {
      value: (_vm.formValidate.productTypeName),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "productTypeName", $$v)
      },
      expression: "formValidate.productTypeName"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "牌号",
      "prop": "shopsign"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入牌号"
    },
    model: {
      value: (_vm.formValidate.shopsign),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "shopsign", $$v)
      },
      expression: "formValidate.shopsign"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "技术标准",
      "prop": "techStandard"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入技术标准"
    },
    model: {
      value: (_vm.formValidate.techStandard),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "techStandard", $$v)
      },
      expression: "formValidate.techStandard"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "是否有效",
      "prop": "isValid"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入是否有效"
    },
    model: {
      value: (_vm.formValidate.isValid),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "isValid", $$v)
      },
      expression: "formValidate.isValid"
    }
  })], 1), _vm._v(" "), _c('FormItem', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "请输入备注"
    },
    model: {
      value: (_vm.formValidate.remark),
      callback: function($$v) {
        _vm.$set(_vm.formValidate, "remark", $$v)
      },
      expression: "formValidate.remark"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "primary",
      "long": "",
      "loading": _vm.modal_loading
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("确定")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0837d70f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/BaseManager/product_type.vue
// module id = 888
// module chunks = 1